import axios from 'axios';
import { endpoints } from './endpoints';

const BASEURL = process.env.VUE_APP_API_SERVEL;
/**
 * Envía correos masivos a periodistas
 * @param {Object} data - Datos del correo con grupo, asunto, cuerpo y archivos
 * @returns {Promise} - Promesa con resultado de la operación
 */
const EnvioCorreos = async (data) => {
    try {
      const response = await axios.post(`${BASEURL}${endpoints.envioCorreos}/enviar`, data, {
        headers: {
          'Content-Type': 'application/json'
        },
        timeout: 31000 // 31 segundos para el timeout
      });
      console.log('response:', response.data);
      return response.data;
    } catch (error) {
      console.error('Error en EnvioCorreosService.enviar:', error);
      throw error;
    }
  }



const getAllGrupos = async () => {
  const url = `${BASEURL}${endpoints.envioCorreos}/listar`
  return axios.get(url).then(response => {
    return response.data.data;
  });
}

export const EnvioCorreosService ={
  getAllGrupos,
  EnvioCorreos

}
